/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from "~/backend/axiosClient"
import type {
  CreateTraceabilitySourceContextMutationRequest,
  CreateTraceabilitySourceContextMutationResponse,
} from "../types/CreateTraceabilitySourceContext.ts"
import type {
  UseMutationOptions,
  UseMutationResult,
  QueryClient,
} from "@tanstack/react-query"
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
  ResponseConfig,
} from "~/backend/axiosClient"
import { mutationOptions, useMutation } from "@tanstack/react-query"

export const createTraceabilitySourceContextMutationKey = () =>
  [{ url: "/v1/traceability-source-contexts" }] as const

export type CreateTraceabilitySourceContextMutationKey = ReturnType<
  typeof createTraceabilitySourceContextMutationKey
>

/**
 * @description Creates a DRAFT source context on an operation anchor. Supplier contact is required; facility and sourceReference are optional.
 * @summary Create a MULTI_SOURCE traceability source context
 * {@link /v1/traceability-source-contexts}
 */
export async function createTraceabilitySourceContext(
  data: CreateTraceabilitySourceContextMutationRequest,
  config: Partial<
    RequestConfig<CreateTraceabilitySourceContextMutationRequest>
  > & { client?: Client } = {}
) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data

  const res = await request<
    CreateTraceabilitySourceContextMutationResponse,
    ResponseErrorConfig<Error>,
    CreateTraceabilitySourceContextMutationRequest
  >({
    method: "POST",
    url: `/v1/traceability-source-contexts`,
    data: requestData,
    ...requestConfig,
  })
  return res
}

export function createTraceabilitySourceContextMutationOptions<
  TContext = unknown,
>(
  config: Partial<
    RequestConfig<CreateTraceabilitySourceContextMutationRequest>
  > & { client?: Client } = {}
) {
  const mutationKey = createTraceabilitySourceContextMutationKey()
  return mutationOptions<
    ResponseConfig<CreateTraceabilitySourceContextMutationResponse>,
    ResponseErrorConfig<Error>,
    { data: CreateTraceabilitySourceContextMutationRequest },
    TContext
  >({
    mutationKey,
    mutationFn: async ({ data }) => {
      return createTraceabilitySourceContext(data, config)
    },
  })
}

/**
 * @description Creates a DRAFT source context on an operation anchor. Supplier contact is required; facility and sourceReference are optional.
 * @summary Create a MULTI_SOURCE traceability source context
 * {@link /v1/traceability-source-contexts}
 */
export function useCreateTraceabilitySourceContext<TContext>(
  options: {
    mutation?: UseMutationOptions<
      ResponseConfig<CreateTraceabilitySourceContextMutationResponse>,
      ResponseErrorConfig<Error>,
      { data: CreateTraceabilitySourceContextMutationRequest },
      TContext
    > & { client?: QueryClient }
    client?: Partial<
      RequestConfig<CreateTraceabilitySourceContextMutationRequest>
    > & { client?: Client }
  } = {}
) {
  const { mutation = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...mutationOptions } = mutation
  const mutationKey =
    mutationOptions.mutationKey ?? createTraceabilitySourceContextMutationKey()

  const baseOptions = createTraceabilitySourceContextMutationOptions(
    config
  ) as UseMutationOptions<
    ResponseConfig<CreateTraceabilitySourceContextMutationResponse>,
    ResponseErrorConfig<Error>,
    { data: CreateTraceabilitySourceContextMutationRequest },
    TContext
  >

  return useMutation<
    ResponseConfig<CreateTraceabilitySourceContextMutationResponse>,
    ResponseErrorConfig<Error>,
    { data: CreateTraceabilitySourceContextMutationRequest },
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient
  ) as UseMutationResult<
    ResponseConfig<CreateTraceabilitySourceContextMutationResponse>,
    ResponseErrorConfig<Error>,
    { data: CreateTraceabilitySourceContextMutationRequest },
    TContext
  >
}
